import $ from 'jquery';
import avalon from 'avalon';
import dialog from 'dialog';
import attrHash from './attribute/hash';
import attrSelected from './attribute/selected';
import slider from 'slider';
import ajax from 'ajax';
import pagination from 'pagination';
import tool from 'toolLoaderPC';
import destinationChooser from './destinationChooser';
import piczoom from 'piczoom';

let evaluateListUrl = '';
let consultListUrl = ''; // 反馈咨询的发布链接

function updateCountAndAddToCart () {
    if (vmodel.canbuy === -1) {
        // 如果不限购
        var min = vmodel.stock;
        if (min === 0) {
            vmodel.count = 0;
        } else {
            if (vmodel.count === 0) {
                vmodel.count = 1;
            } else {
                vmodel.count = tool.min([vmodel.count, vmodel.stock]);
            }
        }
    } else {
        // 如果限购
        var min = tool.min([vmodel.stock, vmodel.canbuy]);
        if (min === 0) {
            vmodel.count = 0;
        } else {
            if (vmodel.count === 0) {
                vmodel.count = 1;
            } else {
                vmodel.count = tool.min([
                    vmodel.count,
                    vmodel.stock,
                    vmodel.canbuy
                ]);
            }
        }
    }
    // 未开始闪购
    if (hiddenValues.activeTime.shopping === 'N') {
        vmodel.addToCartDisable = true;
    } else {
        vmodel.addToCartDisable = min === 0;
    }
}

var sliderInstance, // 大图幻灯插件
    hiddenValues, // 局部隐藏域的值
    groups; // 属性分组

var vmodel = avalon.define({
    $id: 'detailController',

    sku_id: '', // 商品唯一ID

    marketPrice: 0, // 市场价格
    price: 0, // 折后价格
    current_price: 0, // 折后最低价
    presented_voucher: 0, // 赠送的代金券
    // max_voucher: 0, 		// 可抵扣的代金券

    cut: 0, // 折扣
    stock: 0, // 库存
    stockVisible: false,
    attributes: [], // 属性
    imgsKey: '', // 图片标记

    remark: '', // 商品的备注

    limitLabel: '', // 商品限购提示
    canbuy: -1, // 商品限购数量 -1表示不限购

    activeLabel: '', // 商品活动提示
    activeTime: '', // 闪购事件

    sell_total: 0, // 总销量

    mark_tags: [], // 商品营销标签
    star_tags: '', // 商品球星系列

    count: 1,

    // 埋点数据统计
    sendEventTracking: function (n, param) {
        tool.sendEventTracking('pc', n, param);
    },

    minusCount: function () {
        var max = 0,
            count = vmodel.count;

        if (vmodel.count === 0 || vmodel.count === 1) {
            //				dialog.alert('数量不能再少了');
            return;
        }

        if (vmodel.canbuy === -1) {
            if (vmodel.stock > 0) {
                max = 1;
            } else {
                max = 0;
            }
        } else {
            max = tool.min([vmodel.stock, vmodel.canbuy]);
            max = max > 0 ? 1 : 0;
        }
        vmodel.count = Math.max(max, count - 1);
    },
    plusCount: function () {
        if (vmodel.count === vmodel.stock) {
            //				dialog.alert('库存不足');
            return;
        }

        var canbuy = vmodel.canbuy < 0 ? 0 : vmodel.canbuy;
        if (vmodel.canbuy !== -1) {
            if (vmodel.count === vmodel.canbuy) {
                //					dialog.alert('购买数量不能超过所能购买的数量');
                return;
            }
            var min = tool.min([vmodel.stock, vmodel.count + 1, canbuy]);
            vmodel.count = min;
        } else {
            vmodel.count = tool.min([vmodel.stock, vmodel.count + 1]);
        }
    },

    select: function (attr, group) {
        vmodel.sendEventTracking(10300);

        // var key = attr.key;
        var sameLevel = group.list;

        // 判断属性当前状态
        if (attr.disable) {
            // return;
        }
        if (attr.selected) {
            attr.selected = false;
            attrSelected.deleteAttr(attr);
        } else {
            $.each(sameLevel, function (i, attr) {
                attr.selected = false;
            });
            attr.selected = true;
            attrSelected.push(attr);
        }

        // 区分所有属性是否可选
        $.each(groups, function (i, group) {
            attrHash.disable(group.list);
            attrSelected.enable(group.list, group.key, i, groups.length);
        });

        tool.setVMValues(vmodel, {
            remark: ''
        });

        // 判断是否选择了一个商品
        if (groups.length === attrSelected.getLength()) {
            var source = attrHash.querySourceData(
                attrSelected.getSelectedKey(
                    attrSelected.getSelected(),
                    groups.length
                )
            );
            if (!source || attrSelected.getLength(source) === 0) {
                tool.setVMValues(vmodel, {
                    stock: 0,
                    count: 0,
                    price: -1,
                    current_price: attrHash.minPrice
                });
            } else {
                tool.setVMValues(vmodel, {
                    price: source.price,
                    stock: source.number,
                    marketPrice: source.marketPrice,
                    count: Math.min(vmodel.stock, vmodel.count),
                    cut: source.cut,
                    sku_id: source.sku_id,
                    current_price: source.price,
                    remark: source.remark
                });
                getFreight(vmodel.freight.$model);
            }
            vmodel.stockVisible = true;
        } else {
            tool.setVMValues(vmodel, {
                price: attrHash.getPriceRange(),
                stock: attrHash.getTotalStock(),
                cut: attrHash.getCutRange(),
                current_price: attrHash.minPrice,
                stockVisible: false,
                sku_id: ''
            });
        }
        // 更新count和按钮
        updateCountAndAddToCart();

        // 判断是否替换图片
        var imgs = attrSelected.getAttrImgs();
        if (imgs.key) {
            if (vmodel.imgsKey !== imgs.key) {
                if (imgs.imgs && imgs.imgs.length > 0) {
                    sliderInstance.setImgs(imgs.imgs);
                } else {
                    sliderInstance.setImgs(hiddenValues.defaultImg);
                }
            }
            vmodel.imgsKey = imgs.key;
        } else {
            if (vmodel.imgsKey !== 'cover') {
                sliderInstance.setImgs(hiddenValues.defaultImg);
            }
            vmodel.imgsKey = 'cover';
        }

        // 存在秒杀就更新一下秒杀价格
        // 购物车展示的价格 存在秒杀进行时 就减秒杀价， 不存在就直接是商品价格

        if (hiddenValues.panic && hiddenValues.panic.panic_mark) {
            updatePanicPrice();
        }
    },

    addToCartDisable: false,
    addToCart: function () {
        if (vmodel.addToCartDisable) {
            return;
        } else if (groups.length !== attrSelected.getLength()) {
            dialog.alert('请选择商品型号');
            vmodel.sendEventTracking(10401);
            return;
        } else if (tool.toNumber(vmodel.count) === 0) {
            dialog.alert('商品数量不能为0');
            vmodel.sendEventTracking(10401);
            return;
        }

        vmodel.sendEventTracking(10400);

        tool.singleWay('goods-detail-addtocart', function (key) {
            var kit = this;
            ajax.postWithFail(hiddenValues.options.addtocart, {
                sku_id: vmodel.sku_id,
                nums: vmodel.count
            })
                .done(function () {
                    ajax.pjax('/cart_list.html');
                    kit.resolve(key);
                })
                .fail(function () {
                    kit.resolve(key);
                });
        });
    },

    menu: 'detail',
    // 移动到商品咨询
    moveToConsult: function () {
        vmodel.menu = 'consult';
        tool.scrollTo($('#js-consultlist'));
    },

    // 移动到商品详情
    moveToDetail: function () {
        vmodel.menu = 'detail';
        tool.scrollTo($('#goods-det'));
    },

    // 移动到商品评价
    moveToEvaluate: function () {
        vmodel.menu = 'evaluate';
        tool.scrollTo($('#goods-eva'));
    },

    // 咨询列表分页
    consultlist: [],
    consultPagination: pagination.init(10, 1, 10),
    consultGoPage: function (page) {
        if (page.disable) {
            return;
        }
        dialog.mask.show();
        dialog.progress.show(70);
        ajax.getWithFail(consultListUrl, {
            id: hiddenValues.options.goods_id,
            page: page.target
        }).done(function (response) {
            var pageData = response.message;
            vmodel.consultlist = pageData.data;
            vmodel.consultPagination = pagination.init(
                pageData.total,
                pageData.page,
                pageData.count
            );
            dialog.progress.width(100);
            setTimeout(function () {
                dialog.mask.hide();
                dialog.progress.hide();
                vmodel.moveToConsult();
            }, 500);
        });
    },

    // 提交咨询内容
    consultContent: '',
    submitConsult: function () {
        if (vmodel.consultContent === '') {
            dialog.alert('咨询内容不能为空');
            return;
        }
        tool.singleWay('goods-detail-consult', function (key) {
            var kit = this;
            ajax.postWithFail('/feedback/message.html', {
                _csrf: hiddenValues._csrf,
                'FeedbackModel[content]': vmodel.consultContent,
                'FeedbackModel[goods_id]': hiddenValues.options.goods_id
            })
                .done(function () {
                    dialog.alert('咨询发送成功，请耐心等待客服回复');
                    vmodel.consultContent = '';
                    kit.resolve(key);
                })
                .fail(function () {
                    kit.resolve(key);
                });
        });
    },

    // 评价列表
    evaluate: {
        tag: []
    },
    evaluatelist: [],
    evaluateType: 0,
    evaluateChangeType: function (type) {
        if (vmodel.evaluateType != type) {
            vmodel.evaluateType = type;
            vmodel.evaluateGoPage(1);
        }
    },
    evaluatePagination: pagination.init(0, 1, 0),
    evaluateGoPage: function (page) {
        if (page.disable) {
            return;
        }
        dialog.mask.show();
        dialog.progress.show(70);
        ajax.getWithFail(evaluateListUrl, {
            id: hiddenValues.options.goods_id,
            type: vmodel.evaluateType, // 1 => 有图  0 => 所有
            page: page.target
        }).done(function (response) {
            var pageData = response.msg.list;
            vmodel.evaluatelist = evaluateAdd(pageData.evaluates);
            vmodel.evaluatePagination = pagination.init(
                pageData.total,
                pageData.page,
                pageData.count
            );
            dialog.progress.width(100);
            setTimeout(function () {
                dialog.mask.hide();
                dialog.progress.hide();
                vmodel.moveToEvaluate();
            }, 500);
        });
    },
    openMoreMessage: function (el) {
        el.openMoreMessage = 1;
    },
    openImg: function (el, index) {
        piczoom.show(el, index);
    },
    imgRendered: function () {
        $('.lazy-background').lazyload({
            effect: 'fadeIn',
            // placeholder: window.server.cdnHost + '/dest/quanzi/images/default200.jpg',
            threshold: 300
        });
    },

    // 关注
    followed: false, // 已经关注过了
    follow: function () {
        tool.singleWay('goods-detail-follow', function (key) {
            var kit = this,
                url = vmodel.followed
                    ? '/goods/cancel.html'
                    : '/goods/concern.html',
                text = vmodel.followed ? '取消关注成功' : '关注成功';
            ajax.getWithFail(url, { id: hiddenValues.options.goods_id })
                .done(function () {
                    dialog.alert(text);
                    vmodel.followed = !vmodel.followed;
                    kit.resolve(key);
                })
                .fail(function () {
                    kit.resolve(key);
                });
        });
    },

    toTopVisible: true,
    toTopPositionBottom: 335,
    toTop: function () {
        tool.scrollTo($('#header'));
    },

    freight: {},
    changeDestination: function () {
        destinationChooser.open(function (city) {
            vmodel.freight.endDistrictId = city.id;
            vmodel.freight.endDistrictName = city.name;
            getFreight(vmodel.freight.$model);
        }, vmodel.freight.endDistrictId);
    },

    serviceClick: function () {
        _MEIQIA('showPanel');
    },

    panic: {}, // 秒杀信息

    subtitle: '', // 子标题 当为秒杀的时候读秒杀标题

    promotion: [],
    isShowPromotionMask: false,

    isShowPromotion: false,

    togglePromotionClick: function (val) {
        vmodel.isShowPromotion = val;
    },

    getKeyalias: function (val) {
        val = val.length > 5 ? val.substr(0, 5) : val;
        return val + '：';
    }
});

// 数量输入校验
avalon.duplexHooks.count = {
    get: function (val, binding) {
        if (val) {
            var old = val + '';

            while (!/^[0-9]*$/.test(old)) {
                old = old.substr(0, old.length - 1);
            }

            var n, able;
            var count = Number(old);
            if (count > vmodel.stock) {
                able = true;
                old = val + '';
                while (able) {
                    n = old.substr(0, old.length - 1);
                    if (Number(n) > vmodel.stock) {
                        old = n;
                        able = true;
                    } else {
                        able = false;
                    }
                }

                count = Number(n);
            }

            var canbuy = vmodel.canbuy < 0 ? 0 : vmodel.canbuy;
            if (vmodel.canbuy !== -1) {
                if (count > vmodel.canbuy) {
                    var min = tool.min([count, canbuy]);
                    count = min;
                }
            }

            vmodel.count = count;
            if (count != val) {
                binding.element.value = count;
            }

            return count;
        }
    },
    set: function (val) {
        return val;
    }
};

vmodel.$watch(
    'count',
    tool.debounce3(function () {
        getFreight(vmodel.freight.$model);
    }, 500)
);

var getFreight = (function () {
    var dtd = null;
    return function (freight) {
        console.log(vmodel.sku_id);
        dtd = ajax.getWithFail('/freight.html', {
            startDistrictId: freight.startDistrictId,
            endDistrictId: freight.endDistrictId,
            goods_id: hiddenValues.options.goods_id,
            sku_id: vmodel.sku_id || '0',
            num: vmodel.count
        });
        dtd.done(function (respones) {
            vmodel.freight.fee = respones.message.fee;
        });
    };
})();

var timeOper = {
    activeTime: 0,
    format: function () {
        var miniSeconds = 1;
        var time = this.activeTime,
            dayTime = miniSeconds * 60 * 60 * 24,
            days = 0,
            hourTime = miniSeconds * 60 * 60,
            hours = 0,
            minuteTime = miniSeconds * 60,
            minutes = 0,
            secondTime = miniSeconds,
            seconds = 0,
            res = [];

        if (time >= dayTime) {
            days = Math.floor(time / dayTime);
            res.push(tool.fixNum(days) + '天');
            time -= days * dayTime;
        } else {
            res.push('00天');
        }
        if (time >= hourTime) {
            hours = Math.floor(time / hourTime);
            res.push(tool.fixNum(hours) + '时');
            time -= hours * hourTime;
        } else {
            res.push('00时');
        }
        if (time >= minuteTime) {
            minutes = Math.floor(time / minuteTime);
            res.push(tool.fixNum(minutes) + '分');
            time -= minutes * minuteTime;
        } else {
            res.push('00分');
        }
        if (time >= secondTime) {
            seconds = Math.floor(time / secondTime);
            res.push(tool.fixNum(seconds) + '秒');
            time -= seconds * secondTime;
        } else {
            res.push('00秒');
        }
        return res.join('');
    },
    start: function () {
        var that = this;
        that.activeTime = tool.toNumber(hiddenValues.activeTime.timing);
        vmodel.activeLabel = hiddenValues.activeTime.message;

        updateCountAndAddToCart();

        // 未开始闪购且距离时间为0，说闪购已结束
        if (that.activeTime === 0 && hiddenValues.activeTime.shopping === 'N') {
            vmodel.activeLabel = '闪购已结束';
            vmodel.activeTime = '';
            return;
        }
        // 不限购
        if (that.activeTime === 0 && hiddenValues.activeTime.shopping === 'Y') {
            vmodel.activeLabel = '';
            vmodel.activeTime = '';
            return;
        }

        vmodel.activeTime = that.format();
        that.timer = setInterval(function () {
            that.activeTime -= 1;
            vmodel.activeTime = that.format();
            if (that.activeTime === 0) {
                that.stop();
            }
        }, 1000);
    },
    stop: function () {
        clearInterval(this.timer);
    }
};

// 初始化百度分享
window._bd_share_config = {
    common: {
        bdSnsKey: {},
        bdText: '我在爱羽客网站发现一件商品非常不错，希望你能够帮我参考一下',
        bdMini: '2',
        bdMiniList: false,
        bdStyle: '1',
        bdSize: '16',
        bdUrl:
            window.location.href + '?share_uid=' + $("[name='userid']").val(),
        bdPic: ''
    },
    share: {}
};

// 初始化秒杀信息
function initPanic () {
    hiddenValues.panic.formatTime = {};
    hiddenValues.panic.formatTimeInterval = null;
    hiddenValues.panic.endTime = null;
    hiddenValues.panic.panicPrice = null;

    vmodel.panic = hiddenValues.panic;
    if (vmodel.panic.status == 2) {
        var endTime = vmodel.panic.time * 1000 + new Date().getTime();
        vmodel.panic.endTime = endTime;

        vmodel.panic.formatTime = timeFormat();
        vmodel.panic.formatTimeInterval = setInterval(function () {
            vmodel.panic.formatTime = timeFormat();
        }, 1000);
    }
}

// 更新秒杀价格 切换商品属性的时候也要更新秒杀价格
function updatePanicPrice () {
    var separator = '－',
        price = vmodel.price,
        panicPrice = '';

    if ((price + '').indexOf(separator) != -1) {
        var temp = price.split(separator);

        temp[0] = tool.toNumber(temp[0]) - tool.toNumber(vmodel.panic.discount);
        temp[0] = temp[0] <= 0 ? 0 : temp[0];
        temp[0] = tool.toMoney(temp[0]);

        temp[1] = tool.toNumber(temp[1]) - tool.toNumber(vmodel.panic.discount);
        temp[1] = temp[1] <= 0 ? 0 : temp[1];
        temp[1] = tool.toMoney(temp[1]);

        panicPrice = temp[0] + separator + temp[1];
    } else {
        panicPrice =
            tool.toNumber(price) - tool.toNumber(vmodel.panic.discount);
        panicPrice = tool.toMoney(panicPrice);
    }

    vmodel.panic.panicPrice = panicPrice;
}

// 把秒转换为时间对象
function timeFormat () {
    var time = Math.floor((vmodel.panic.endTime - new Date().getTime()) / 1000);
    if (time <= 0) {
        return {
            day: 0,
            hour: 0,
            minute: 0,
            second: 0
        };
    }

    var day = Math.floor(time / (24 * 60 * 60));
    time = time - day * 24 * 60 * 60;
    var hour = Math.floor(time / (60 * 60));
    time = time - hour * 60 * 60;
    var minute = Math.floor(time / 60);
    time = time - minute * 60;
    var second = time;

    return {
        day: day,
        hour: hour >= 10 ? hour : '0' + hour,
        minute: minute >= 10 ? minute : '0' + minute,
        second: second >= 10 ? second : '0' + second
    };
}

// 给评价数据增加参数
function evaluateAdd (arr) {
    for (var i = 0; i < arr.length; i++) {
        arr[i].openMoreMessage = 0;
    }
    return arr;
}

export default {
    init: function () {
        // 设置顶部提示为显示 点击后隐藏
        $('body').css('min-width', '1540px');
        $('.shangou-remind').show();
        $('.shangou-remind .know').click(function () {
            $('.shangou-remind').hide();
        });

        hiddenValues = tool.getHiddenValues('#js-local-hiddens');
        // console.log(hiddenValues.promotion)

        sliderInstance = slider.init({
            selector: '#js-slider',
            imgs: hiddenValues.defaultImg,
            pagination: {
                selector: '#js-slider-pagination',
                render: function (item) {
                    return item.html();
                }
            }
        });

        consultListUrl = hiddenValues.outPage.url;
        evaluateListUrl = hiddenValues.get_evaluate;
        hiddenValues.evaluate.list.evaluates = evaluateAdd(
            hiddenValues.evaluate.list.evaluates
        );

        if (hiddenValues.attributes && hiddenValues.attributes.length) {
            attrHash.initData(hiddenValues.attributes);
            groups = attrHash.toGroups();
            var hint = hiddenValues.shoppingLimit.hint; // 限购

            // hiddenValues.options.voucher.max_voucher = tool.toNumber(hiddenValues.options.voucher.max_voucher);
            hiddenValues.options.voucher.presented_voucher = tool.toNumber(
                hiddenValues.options.voucher.presented_voucher
            );

            // 运费初始化
            hiddenValues.freight.fee = tool.toMoney(hiddenValues.freight.fee);

            tool.setVMValues(vmodel, {
                attributes: groups,
                // 获取咨询列表
                consultlist: hiddenValues.outPage.data,
                consultPagination: pagination.init(
                    hiddenValues.outPage.total,
                    hiddenValues.outPage.page,
                    hiddenValues.outPage.count
                ),
                // 获取评价列表
                evaluatelist: hiddenValues.evaluate.list.evaluates,
                evaluatePagination: pagination.init(
                    hiddenValues.evaluate.list.total,
                    hiddenValues.evaluate.list.page,
                    hiddenValues.evaluate.list.count
                ),
                // 获取商品属性
                marketPrice: attrHash.getMarketPriceRange(),
                price: attrHash.getPriceRange(),
                stock: attrHash.getTotalStock(),
                cut: attrHash.getCutRange(),
                limitLabel: hint === -1 ? '本件商品不限购' : hint,
                canbuy: hiddenValues.shoppingLimit.can_buy,
                followed: tool.toNumber(hiddenValues.options.concern) === 1, // 关注
                freight: hiddenValues.freight,
                sell_total: hiddenValues.options.sell_total,
                // max_voucher: 						hiddenValues.options.voucher.max_voucher,
                presented_voucher:
                    hiddenValues.options.voucher.presented_voucher,
                current_price: attrHash.minPrice,
                mark_tags: hiddenValues.mark_tags,
                star_tags: hiddenValues.star_tags,
                evaluate: hiddenValues.evaluate
            });
            attrHash.replaceAttrs(groups);
            updateCountAndAddToCart();

            // 异步获取地址信息
            ajax.getJSON('/goods/default/get-city-freight.html', {
                goods_id: hiddenValues.options.goods_id
            }).done(function (response) {
                if (response.type === 'success' || response.type === 'succ') {
                    tool.setVMValues(vmodel, {
                        freight: response.msg
                    });
                }
            });

            // 区分所有属性是否可选
            $.each(groups, function (i, group) {
                attrHash.disable(group.list);
                attrSelected.enable(group.list, group.key, i, groups.length);
            });

            // 计时器
            timeOper.start();

            // 商品TAB标签随屏幕滚动
            var $tabs = $('#js-fixed-tabs'),
                offset = $tabs.offset();
            tool.onWindowScroll.on(function (e, top) {
                if (top === 0) {
                    vmodel.toTopVisible = false;
                } else {
                    vmodel.toTopVisible = true;
                }

                var clientHeight = tool.getClientHeight(),
                    scrollHeight = tool.getScrollHeight();

                if (scrollHeight - clientHeight - top < 335) {
                    vmodel.toTopPositionBottom =
                        335 - (scrollHeight - clientHeight - top);
                } else {
                    vmodel.toTopPositionBottom = 20;
                }

                if (top > offset.top) {
                    if (!$tabs.hasClass('fixed')) {
                        $tabs.addClass('fixed');
                        $tabs.parent().addClass('haspad');
                        setTimeout(function () {
                            $tabs.css({ top: 0 });
                        }, 0);
                    }
                } else {
                    if ($tabs.hasClass('fixed')) {
                        $tabs.parent().removeClass('haspad');
                        $tabs.removeClass('fixed').css({ top: -55 });
                    }
                }
            });

            tool.onWindowScroll.trigger();

            window._bd_share_config.common.bdPic = hiddenValues.defaultImg[0];

            // 初始化百度分享
            if (window._bd_share_main) {
                window._bd_share_main.init();
            } else {
                let script = document.createElement('script');
                script.src =
                    '//bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion=' +
                    ~(-new Date() / 36e5);
                document.getElementsByTagName('head')[0].appendChild(script);
            }

            // 有秒杀活动就执行
            hiddenValues.panic && hiddenValues.panic.panic_mark && initPanic();
            // 子标题
            vmodel.subtitle =
                hiddenValues.panic && hiddenValues.panic.panic_mark
                    ? hiddenValues.panic.panic_title
                    : hiddenValues.promotion && hiddenValues.promotion.show_mark
                        ? hiddenValues.promotion.panic_title
                        : hiddenValues.goodsProvider.subtitle;

            // 存在秒杀就更新一下秒杀价格
            // 购物车展示的价格 存在秒杀进行时 就减秒杀价， 不存在就直接是商品价格
            if (hiddenValues.panic && hiddenValues.panic.panic_mark) {
                updatePanicPrice();
            }

            // 促销信息
            if (hiddenValues.promotion && hiddenValues.promotion.show_mark) {
                vmodel.promotion = hiddenValues.promotion.active_info;
                vmodel.isShowPromotionMask =
                    hiddenValues.promotion.show_mark == 'Y';
            }
        }

        vmodel.sendEventTracking(10201, {
            goodsid: hiddenValues.options.goods_id
        });

        $('img[data-original]').lazyload({
            effect: 'fadeIn'
        });
        vmodel.imgRendered();

        piczoom.init();
    },
    clear: function () {
        timeOper.stop();
        attrSelected.clear();
        attrHash.clear();
        tool.onWindowScroll.clear();

        tool.setVMValues(vmodel, {
            consultContent: '',
            submitConsultLoading: false,
            addToCartLoading: false,
            addToCartDisable: false,
            stockVisible: false,
            count: 1,
            sell_total: 0
        });
        $('body')
            .children('[id^=bdshare_],[class^=bdshare_],[class^=bd_]')
            .hide();
        $('.shangou-remind').hide();

        // 取消秒杀定时器
        if (vmodel.fanic && vmodel.fanic.formatTimeInterval) {
            clearInterval(vmodel.fanic.formatTimeInterval);
        }
    }
};



// WEBPACK FOOTER //
// ./src/js_modules/detailController.js